module.exports = __webpack_public_path__ + "static/media/22.Waving Hand 5.ab9260c2.gif";